import React, { useEffect, useState } from "react";

import PhoneInput from "react-phone-input-2";
import { edit_icon, img_placehlder } from "../../../../assets";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  allowAlphaNumeric,
  allowAlphabetsWithSpace,
  areMandatoryFieldsFilled,
} from "../../../../utils/inputValueValidation";
import {
  CommonSelect,
  DatePicker,
  Input,
  LoadingButton,
  Select,
} from "../../../../Components/header/form";
import { gender, twelveYearsAgo } from "../../../../utils/staticData";
import { imageHandler } from "../../../../utils/imageHandler";
import DP from "../../../../assets/profilePlaceholder.jpg";
import {
  fetchCityListApi,
  fetchCountryListApi,
  fetchStateListApi,
} from "../../../../services/common";
import { deleteUserApi, updateUserProfileApi } from "../../../../services/auth";
import multipartDataHelper from "../../../../utils/sendMultipartDataHelper";
import CustomModal from "../../../../Components/modals/CustomModal";
import DeleteModal from "../../../../Components/modals/DeleteModal";
import { toastMessage } from "../../../../utils/toastMessage";
import { setShowAuth } from "../../../../store/slices/showAuthSlice";
import { validateInput } from "../../../../schema/inputValidation";
import { updateProfile } from "../../../../schema/updateProfile/updateProfile";
import { isTrue } from "../../../../utils/commonHelper";
import { GiHamburgerMenu } from "react-icons/gi";

const PersonalDetails = () => {
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [error, setError] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [phone, setPhone] = useState({});
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [whatsappPhone, setWhatsappPhone] = useState({});
  const [tab, setTab] = useState("profileDetails");
  const [accountDeleteModal, setAccountDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  //   Fetching Country List
  const fetchCountryList = async () => {
    try {
      const { data } = await fetchCountryListApi();
      const { success, data: response } = data;
      if (success) {
        setCountryList(
          response?.map((data) => ({
            label: data?.name,
            value: data?.id,
          }))
        );
      } else {
        setCountryList([]);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    let updatedValue = value;
    if (name === "fullName") {
      updatedValue = allowAlphabetsWithSpace(value);
    }
    if (name === "profession") {
      updatedValue = allowAlphabetsWithSpace(value);
    }
    if (name === "nickname") {
      updatedValue = allowAlphabetsWithSpace(value);
    }
    if (name === "sameAsRegistered") {
      updatedValue = checked;
      // if (!checked) {
      //   setWhatsappPhone("");
      // }
      setWhatsappPhone({
        whatsappDialCode: showAuth?.contact?.whatsappNumber?.dialCode || "+1",
        whatsappNumber: showAuth?.contact?.whatsappNumber?.number || "",
        whatsappCompleteMobile: `${showAuth?.contact?.whatsappNumber?.dialCode || "+1"
          }${showAuth?.contact?.whatsappNumber?.number || ""}`,
      });
    }
    if (name === "state" || name === "city") {
      updatedValue = allowAlphabetsWithSpace(value);
    }
    setUserData({ ...userData, [name]: updatedValue });
  };

  const handlePhoneChange = (phone, country) => {
    const phoneWithoutCountryCode = phone.replace(country.dialCode, "");
    setPhone({
      number: phoneWithoutCountryCode,
      completeMobile: `+${country?.dialCode}${phoneWithoutCountryCode}` || "+1",
      dialCode: `+${country?.dialCode}`,
    });
  };

  //   Handle Phone Change
  const handleWhatsappPhoneChange = (phone, country) => {
    const phoneWithoutCountryCode = phone.replace(country?.dialCode, "");
    setWhatsappPhone({
      whatsappNumber: phoneWithoutCountryCode,
      whatsappCompleteMobile:
        `+${country?.dialCode}${phoneWithoutCountryCode}` || "+1",
      whatsappDialCode: `+${country?.dialCode}`,
    });
  };

  // const validation = () => {
  //   const inputData = {
  //     ...userData,
  //     dateOfBirth: dateOfBirth,
  //     whatsappNumber: whatsappPhone?.whatsappNumber,
  //     number: phone?.number,
  //     country: selectedCountry?.label,
  //   };

  //   const { status, errors } = validateInput(
  //     inputData,
  //     "updateProfileSchema",
  //     updateProfile,
  //     null
  //   );
  //   setError(errors);
  //   return status;
  // };

  const requiredFields = [
    "fullName",
    "email",
    "gender",
    "country",
    // "state",
    "city",
    "whatsappNumber",
  ];

  const formFields = {
    fullName: userData?.fullName,
    email: userData?.email,
    gender: userData?.gender,
    country: selectedCountry?.label,
    // state: userData?.state,
    city: userData?.city,
    whatsappNumber: whatsappPhone?.whatsappNumber,
  };

  const updateUserProfileHandler = async (e) => {
    e.preventDefault();
    // if (validation()) {
    setUpdateLoading(true);
    try {
      // Prepare payload
      const { completeMobile, ...restPhoneData } = phone;
      // Prepare formData
      const formData = new FormData();
      if (profileImage && profileImage?.name) {
        formData.append("profile", profileImage);
      }
      if (selectedCountry?.value && selectedCountry?.label) {
        formData.append("countryId", selectedCountry?.value);
        formData.append("country", selectedCountry?.label);
      }
      if (!userData?.sameAsRegistered) {
        formData.append("whatsappNumber", whatsappPhone?.whatsappNumber);
        formData.append("whatsappDialCode", whatsappPhone?.whatsappDialCode);
      }

      // Add payload to formData
      multipartDataHelper(formData, {
        ...userData,
        ...restPhoneData,
        sameAsRegistered: isTrue(userData?.sameAsRegistered),
      });

      // Make API call
      const { data } = await updateUserProfileApi(formData);
      const { success, message, data: response } = data;
      if (success) {
        toastMessage(message, "success", "updateProfile");
        // console.log(response);
        dispatch(
          setShowAuth({
            ...showAuth,
            profilePicture:
              profileImage &&
              profileImage?.name &&
              URL.createObjectURL(profileImage),
            ...response,
          })
        );
      }
    } catch (error) {
      console.error("Error updating user profile:", error.message);
    } finally {
      setUpdateLoading(false);
    }
    // }
  };

  // Delete Account Handler
  const deleteAccountHandler = async () => {
    try {
      setLoading(true);
      const { data } = await deleteUserApi();
      const { success, message } = data;
      if (success) {
        toastMessage(message, "success", "DeleteAcount");
        setAccountDeleteModal(false);
        localStorage.removeItem("logic_chat_token");
        navigate("/");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setUserData({
      fullName: showAuth?.fullName || "",
      nickname: showAuth?.nickname || "",
      email: showAuth?.contact?.email || "",
      sameAsRegistered: showAuth?.sameAsRegistered,
      instagram: showAuth?.socialMediaLinks?.instagram || "",
      facebook: showAuth?.socialMediaLinks?.facebook || "",
      x: showAuth?.socialMediaLinks?.x || "",
      profession: showAuth?.profession || "",
      gender: showAuth?.gender || "",
      // state: showAuth?.address?.state || "",
      city: showAuth?.address?.city || "",
    });
    setProfileImage(showAuth?.profilePicture || "");
    setDateOfBirth(showAuth?.dateOfBirth || "");
    setWhatsappPhone({
      whatsappDialCode: showAuth?.contact?.whatsappNumber?.dialCode || "+1",
      whatsappNumber: showAuth?.contact?.whatsappNumber?.number || "",
      whatsappCompleteMobile: `${showAuth?.contact?.whatsappNumber?.dialCode || "+1"
        }${showAuth?.contact?.whatsappNumber?.number || ""}`,
    });
    setPhone({
      dialCode: showAuth?.contact?.mobileNumber?.dialCode || "+1",
      number: showAuth?.contact?.mobileNumber?.number || "",
      completeMobile: `${showAuth?.contact?.mobileNumber?.dialCode || "+1"}${showAuth?.contact?.mobileNumber?.number || ""
        }`,
    });
    setSelectedCountry({
      label: showAuth?.address?.country,
      value: showAuth?.address?.countryId,
    });
  }, [showAuth]);

  useEffect(() => {
    if (userData?.sameAsRegistered && phone?.number && phone?.dialCode) {
      setWhatsappPhone({
        whatsappDialCode: phone?.dialCode || "+1",
        whatsappNumber: phone?.number,
        whatsappCompleteMobile: `${phone?.dialCode}${phone?.number}`,
      });
    }
  }, [userData?.sameAsRegistered]);

  // country
  useEffect(() => {
    fetchCountryList();
  }, []);

  // Delete Profile Image
  const deleteProfileImage = async (e) => {
    setDeleteLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("profile", "");
      const { data } = await updateUserProfileApi(formData);
      const { success, message, data: response } = data;
      toastMessage(
        "Profile Image Remove Successfuly",
        success ? "success" : "error",
        "createUser"
      );
      if (success) {
        setProfileImage("");
        dispatch(
          setShowAuth({
            ...showAuth,
            profilePicture:
              profileImage &&
              profileImage?.name &&
              URL.createObjectURL(profileImage || DP),
          })
        );
      } else {
        toastMessage(message, 'error', 'profileElse')
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <>
      <div className="profile_details">



        <h3 className="profile_title">Personal Information</h3>

        <div className="user_icon">
          <img
            className="profileImg"
            src={
              profileImage && profileImage?.name
                ? URL.createObjectURL(profileImage)
                : profileImage || DP
            }
          />
          <input
            type="file"
            id="profile_picture"
            onChange={(e) => imageHandler(e, setProfileImage, "image", null)}
            accept="image/*"
          />
          <label htmlFor="profile_picture" className="edit-icon">
            <img src={edit_icon} />
          </label>
          <LoadingButton
            isDisabled={!profileImage}
            loading={deleteLoading}
            className={`button next-button ${!profileImage ? "cstm_disabled_btn" : ""
              }`}
            onClick={deleteProfileImage}
          >
            Remove Profile Image
          </LoadingButton>
        </div>

        <form className="accnt_stting_form">
          <div className="form_field_wrap">
            <div className="form-group">
              <Input
                required
                label="Your Name"
                type="text"
                id="nickname"
                name="fullName"
                value={userData?.fullName}
                onChange={handleChange}
                className="input form-control"
                placeholder="Enter Your Name"
                error={error?.fullName}
              />
            </div>

            <div className="form-group">
              <Input
                label="Nickname"
                type="text"
                id="nickname"
                name="nickname"
                value={userData?.nickname}
                onChange={handleChange}
                className="input form-control"
                placeholder="Enter Your Nick Name"
                error={error?.nickname}
              />
            </div>
          </div>

          <div className="form_field_wrap">
            <div className="form-group">
              <label className="label" for="name">
                Phone No
              </label>
              <div className="whatapp_no">
                <PhoneInput
                  country={"ca"}
                  value={phone?.completeMobile || "+1"}
                  enableSearch={true}
                  disabled
                  placeholder={"Enter Mobile Number"}
                  countryCodeEditable={false}
                  onChange={handlePhoneChange}
                  className="phoneInput"
                />
                {error?.number && !phone?.number && (
                  <span
                    className={`${error?.number && !phone?.number
                        ? "invalid-feedback d-block"
                        : ""
                      }`}
                  >
                    {error?.number}
                  </span>
                )}
              </div>
            </div>

            <div className="form-group">
              <Input
                required
                label="Email"
                type="text"
                id="email"
                name="email"
                value={userData?.email}
                onChange={handleChange}
                className="input form-control"
                placeholder="Enter Your Name"
                error={error?.email}
                extraError={error?.emailErr}
              />
            </div>
          </div>

          <div className="form_field_wrap">
            <div className="form-group">
              <DatePicker
                label=" Date of Birth"
                disabled
                value={dateOfBirth}
                maxDate={twelveYearsAgo}
              />
            </div>
            <div className="form-group">
              <Select
                label="Gender"
                required
                className="input form-control"
                id="gender"
                name="gender"
                value={userData?.gender}
                onChange={handleChange}
              >
                <option value="" disabled selected>
                  Select Your Gender
                </option>
                {gender?.map((data) => (
                  <option value={data?.value} key={data?.value}>
                    {data?.name}
                  </option>
                ))}
              </Select>
            </div>
          </div>

          <div className="form_field_wrap">
            <div className="form-group">
              <label className="label" for="name">
                Whatapp No.
              </label>
              <div className="whatapp_no">
                <PhoneInput
                  // country={"ca"}
                  disabled={userData?.sameAsRegistered}
                  value={whatsappPhone?.whatsappCompleteMobile || "+1"}
                  enableSearch={true}
                  countryCodeEditable={false}
                  onChange={handleWhatsappPhoneChange}
                  className="phoneInput"
                />
                {error?.whatsappNumber && !whatsappPhone?.whatsappNumber && (
                  <span
                    className={`${error?.whatsappNumber && !whatsappPhone?.whatsappNumber
                        ? "invalid-feedback d-block"
                        : ""
                      }`}
                  >
                    {error?.whatsappNumber}
                  </span>
                )}
              </div>
            </div>

            <div className="form-group">
              <Input
                label="Profession"
                type="text"
                id="nickname"
                className="input form-control"
                placeholder="Enter Your Profession"
                name="profession"
                value={userData?.profession}
                onChange={handleChange}
                error={error?.profession}
              />
            </div>
          </div>

          <div className="regist_no">
            <input
              type="checkbox"
              name="sameAsRegistered"
              checked={userData?.sameAsRegistered}
              value={userData.sameAsRegistered}
              onChange={handleChange}
            />
            <span> &nbsp;&nbsp;Same as registered number</span>
          </div>

          <div className="form_field_wrap country">
            <div className="form-group">
              <CommonSelect
                required
                label="Country"
                options={countryList}
                placeholder="Select Country"
                value={selectedCountry}
                onChange={(country) => {
                  setSelectedCountry(country);
                }}
                isSearchable
                isMulti={false}
              />
            </div>

              {/* <div className="form-group">
                <Input
                  required
                  label="State"
                  type="text"
                  id="state"
                  name="state"
                  value={userData?.state}
                  onChange={handleChange}
                  className="input form-control"
                  placeholder="Enter State"
                />
              </div> */}

            <div className="form-group">
              <Input
                required
                label="City"
                type="text"
                id="city"
                name="city"
                value={userData?.city}
                onChange={handleChange}
                className="input form-control"
                placeholder="Enter City"
              />
            </div>
          </div>

          <div className="form_field_wrap">
            <div className="form-group">
              <Input
                type="text"
                id="instagram"
                name="instagram"
                label="Instagram Link"
                value={userData?.instagram}
                onChange={handleChange}
                className="input form-control"
                placeholder="Enter instagram link"
                error={error?.instagram}
                extraError={error?.instagramErr}
              />
            </div>

            <div className="form-group">
              <Input
                label="Facebook Link"
                type="text"
                id="facebook"
                name="facebook"
                value={userData?.facebook}
                onChange={handleChange}
                className="input form-control"
                placeholder="Enter facebook link"
                error={error?.facebook}
                extraError={error?.facebookErr}
              />
            </div>
          </div>

          <div className="form_field_wrap">
            <div className="form-group">
              <Input
                label="X Link"
                type="text"
                id="x"
                name="x"
                value={userData?.x}
                onChange={handleChange}
                className="input form-control"
                placeholder="Enter X link"
                error={error?.x}
                extraError={error?.xErr}
              />
            </div>
          </div>

          <div className="personal_info_btn">
            <button
              className="delete_btn"
              onClick={(e) => {
                setAccountDeleteModal(true);
                e.preventDefault();
              }}
            >
              Delete Account
            </button>

            <LoadingButton
              loading={updateLoading}
              isDisabled={!areMandatoryFieldsFilled(formFields, requiredFields)}
              className="save_and_update"
              onClick={updateUserProfileHandler}
            >
              Save & Update
            </LoadingButton>
          </div>
        </form>
      </div>

      <DeleteModal
        show={accountDeleteModal}
        handleClose={() => setAccountDeleteModal(false)}
        deleteAccountHandler={deleteAccountHandler}
        loading={loading}
      />
    </>
  );
};

export default PersonalDetails;
